module.exports = __webpack_public_path__ + "media/images/example-8c3169ce0454ed273a075ce6e4a1d2a5.jpg";